import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Keeps the product page clearance label in sync with the selected variant.
 *
 * A variant change only morphs the variant picker, so the badge is re-resolved in Liquid and this
 * component swaps itself with the node from the freshly rendered section.
 *
 * @extends {Component}
 */
export class NaClearanceBadgeComponent extends Component {
    #abortController = new AbortController();

    connectedCallback() {
        super.connectedCallback();

        const section = this.closest('.shopify-section');

        section?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, {
            signal: this.#abortController.signal,
        });
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        this.#abortController.abort();
    }

    /**
     * @param {Event} event
     */
    #handleVariantUpdate = (event) => {
        const html = /** @type {any} */ (event).detail?.data?.html;
        const blockId = this.dataset.blockId;
        const updated =
            html?.querySelector(`na-clearance-badge-component[data-block-id='${blockId}']`) ??
            html?.querySelector(`na-clearance-badge[data-block-id='${blockId}']`);

        if (!updated) return;

        this.replaceWith(updated);
    };
}

if (!customElements.get('na-clearance-badge-component')) {
    customElements.define('na-clearance-badge-component', NaClearanceBadgeComponent);
}

if (!customElements.get('na-clearance-badge')) {
    class NaClearanceBadgeAlias extends NaClearanceBadgeComponent {}
    customElements.define('na-clearance-badge', NaClearanceBadgeAlias);
}
